// Upload a recorded word sample to the server.
//
// word + slot + ext travel as query params so the server needs no multipart
// parser; the request body is the raw audio blob. A matching local dev server
// lives in scripts/upload-server.mjs. Set UPLOAD_URL in config.js to enable it;
// leave it '' to keep recordings on the device only.

import { UPLOAD_URL } from './config.js'

export function uploadConfigured() { return !!UPLOAD_URL }

export async function uploadSample(wordId, slot, blob, ext) {
  if (!UPLOAD_URL) throw new Error('No upload server configured')
  const sep = UPLOAD_URL.includes('?') ? '&' : '?'
  const url = `${UPLOAD_URL}${sep}word=${encodeURIComponent(wordId)}&slot=${slot}&ext=${encodeURIComponent(ext)}`
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': blob.type || 'application/octet-stream' },
    body: blob,
  })
  if (!res.ok) throw new Error(`Upload failed (${res.status})`)
  return true
}
